import { useTranslation } from "react-i18next"
import { Step } from "react-joyride"
import { CustomBodyText, CustomHeader } from "../manualComponets"

export const vesselStatusSteps = (
	translationFunc?: ReturnType<typeof useTranslation>["t"]
): Step[] => {
	const t = translationFunc ?? ((text: string) => text)
	return [
		{
			target: "#header-user-manual",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("vesselStatus.pageHeader.header")}</CustomHeader>
					<CustomBodyText>{t("vesselStatus.pageHeader.content")}</CustomBodyText>
				</div>
			),
			placement: "left",
			disableBeacon: true,
		},
		{
			target: "#from",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("vesselStatus.from.header")}</CustomHeader>
					<CustomBodyText>{t("vesselStatus.from.content")}</CustomBodyText>
				</div>
			),
			disableBeacon: true,
		},
		{
			target: "#map-section",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("vesselStatus.mapSection.header")}</CustomHeader>
					<CustomBodyText>{t("vesselStatus.mapSection.content")}</CustomBodyText>
				</div>
			),
			disableBeacon: true,
		},
		{
			target: "#wind-or-wave",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("vesselStatus.weatherConditionsSection.header")}</CustomHeader>
					<CustomBodyText>
						{t("vesselStatus.weatherConditionsSection.content")}
					</CustomBodyText>
				</div>
			),
			placement: "left",
			disableBeacon: true,
		},
		{
			target: "#data_view",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("vesselStatus.dataDisplayMode.header")}</CustomHeader>
					<CustomBodyText>{t("vesselStatus.dataDisplayMode.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom",
			disableBeacon: true,
		},
		{
			target: "#fuel-consumption-section",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("vesselStatus.fuelConsumptionSection.header")}</CustomHeader>
					<CustomBodyText>
						{t("vesselStatus.fuelConsumptionSection.content")}
					</CustomBodyText>
				</div>
			),
			placement: "top",
			disableBeacon: true,
		},
		{
			target: "#power-production-section",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("vesselStatus.powerProductionSection.header")}</CustomHeader>
					<CustomBodyText>
						{t("vesselStatus.powerProductionSection.content")}
					</CustomBodyText>
				</div>
			),
			placement: "top",
			disableBeacon: true,
		},
		{
			target: "#power-consumption-section",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("vesselStatus.powerConsumptionSection.header")}</CustomHeader>
					<CustomBodyText>
						{t("vesselStatus.powerConsumptionSection.content")}
					</CustomBodyText>
				</div>
			),
			placement: "top",
			disableBeacon: true,
		},
	]
}
